const fixFFWebProtocol = () => {

    // Select all input fields of type 'url'
    const urlInputs = document.querySelectorAll('input[type="url"]');
    if (urlInputs) {
        urlInputs.forEach(input => {
            input.addEventListener('focusout', addHttpsProtocol);
        });
    }

}
// Funkce pro přidání protokolu https, pokud není zadán
const addHttpsProtocol = (event) => {
    setTimeout(() => {
        const inputField = event.target;
        let url = inputField.value;

        // Zkontrolujte, zda URL začíná na http:// nebo https://
        // Check if the URL starts with http:// and not https://
        if (url.match(/^http:\/\//) && !url.match(/^https:\/\//)) {
            // Replace http:// with https://
            url = url.replace(/^http:\/\//, 'https://');
            inputField.value = url;
        }
    }, 100); // Delay of 200ms
};




const initFormFunctions = () => {

    fixFFWebProtocol();
}
export { initFormFunctions };